module.exports = __webpack_public_path__ + "static/media/ann.345052bd.png";